import DashboardTableRow from "~/components/DashboardTableRow/DashboardTableRow"

import "./DashboardTable.scss"

import { getSpaceForUser } from "../../utils/SpaceUtils"
import { useSelector } from "react-redux"
import { getSpaces } from "~/store"
import { UserWithStats } from "~/utils/DashboardUtils"
import { formattedWeekLabel } from "~/utils/TimeFormatter"

type DashboardTableProps = {
  users: UserWithStats[]
  weekOffset: number
}

function DashboardTable({ users = [], weekOffset }: DashboardTableProps) {
  const spaces = useSelector(getSpaces) ?? []

  const userRows = users.map((user, index) => {
    const space = weekOffset === 0 ? getSpaceForUser(spaces, user) : null
    return (
      <DashboardTableRow
        index={index}
        user={user}
        key={user.id}
        weekOffset={weekOffset}
        timer={space ? space.current_timer : undefined}
      />
    )
  })

  return (
    <div
      className={`DashboardTable${weekOffset === 0 ? " DashboardTable--current-week" : ""}`}
    >
      <div className="DashboardTable__header">
        <div>Name</div>
        {weekOffset === 0 ? (
          <>
            <div>Pomodoros today</div>
            <div>Pomodoros this week</div>
            <div>Time left</div>
          </>
        ) : (
          <div>
            Pomodoros {formattedWeekLabel(weekOffset).toLocaleLowerCase()}
          </div>
        )}
        <div></div>
      </div>
      {userRows}
    </div>
  )
}

export default DashboardTable
